import CardFollowUs from './CardFollowUs';
import ErorBundary from '../../ErrorBoundary';

export default function CardFollowUsContainer() {
	return (
		<ErorBundary>
			<CardFollowUs />
		</ErorBundary>
	);
}
